<template>
  <div class="content-wrap">
    <NaviBox/>
    <div class="tit-group02">
      <h2 class="tit">{{t('message.behaviorManagementList')}}</h2>
    </div>
    <div class="content-box">
      <div class="sort-group">
        <div class="sort-row">
          <div class="wl">
            <div class="txt-total">Total: {{ totalCnt }}</div>
            <c-InputSearch :placeholder="t('message.searchPlaceholder')" v-model="inputSearch" @search-word="onClickSearch"/>
          </div>
          <div class="wr">
            <Select v-bind="sortSelect" v-model="sortType"/>
            <c-btn01 :btnText="t('message.newRegistration')" @click="onClickViewPage"/>
          </div>
        </div>
      </div>
      <!-- v-data-table 가져옴-->
      <div class="tbl-group size-custom7">
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="items"
          :items-per-page-options="footerOptions"
          return-object
          show-select
          @click:row="onClickViewPage"
        >
          <template v-slot:item.behaviorTitle="{ item }">
            <div class="ell01">
              {{item.behaviorTitle}}
            </div>
            <div class="txt-tag">
              {{item.tag}}
            </div>
          </template>
          <template v-slot:item.btnCopy="{ item }">
            <div class="flex-c">
              <c-btnText01 v-bind="btnCopy" @click.prevent.stop="onClickCopy(item.idx)"/>
            </div>
          </template>
        </v-data-table>
      </div>
      <div class="bottom-btn-group">
        <div class="wl"></div>
        <div class="wr">
          <c-btn02 :btnText="t('message.bulkDelete')" @click="dialogAllDeleteModel=true"/>
        </div>
      </div>
    </div>
  </div>
  <c-dialog v-model="dialogCopyModel"
            v-bind="dialogCopyBind"
            @close="dialogCopyModel=false"
            @confirm="confirmCopy()"
  />
  <c-dialog v-model="dialogAllDeleteModel"
            v-bind="dialogAllDeleteBind"
            @close="dialogAllDeleteModel=false"
            @confirm="confirmDelete()"
  />
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import BbsService from "@/services/bbs.service";
import utils from "@/common/Utils";
import _ from 'lodash';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
const snackbar = ref(false)
const snackText = ref('')
const totalCnt = ref(0)
const inputSearch = ref(null)
const dialogCopyModel = ref(false)
const dialogAllDeleteModel = ref(false)
const selected = ref([])
const sortType = ref('0')
const items = ref([])

//ui
const footerOptions = [
  { value: 5, title: '5' },
  { value: 10, title: '10' },
  { value: 25, title: '25' },
  { value: 50, title: '50' },
  { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
]
const headers = ref([
  { title: t('message.behavior'), key: 'behaviorTitle' },
  { title: t('message.category'), key: 'sortTypeText' },
  { title: t('message.categoryType'), key: 'categoryTitle'},
  { title: t('message.observationItem'), key: 'behaviorContent' },
  { title: t('message.detailedObservationItem'), key: 'commentCnt' },
  { title: t('message.isRequired'), key: 'essentialYn' },
  { title: t('message.creationDate'), key: 'regDateFormat' },
  { title: t('message.copy'), key: 'btnCopy' },
])
const dialogCopyBind = {
  dialogTit: t('message.actionCopy'),
  dialogText: t('message.actionCopyDescription'),
  btn1Text: t('message.confirm'),
  btn1Show: true,
  btn2Text: t('message.cancel'),
  btn2Show: true,
}
const dialogAllDeleteBind = {
  dialogTit: t('message.actionDelete'),
  dialogText: t('message.deleteConfirmation'),
  btn1Text: t('message.delete'),
  btn1Show: true,
  btn2Text: t('message.cancel'),
  btn2Show: true,
}
const sortSelect = {
  select: t('message.all'),
  items: [{name: t('message.all'), value: '0'}, {name: t('message.behavior'), value: '1'}, {name: t('message.status'), value: '2'}]
}
const btnCopy = {
  btnText: t('message.copy')
}

//hook
let copyIdx = null
onMounted(() => {
  onClickSearch()
})

//watch
watch(sortType, (newValue) => {
  onClickSearch()
})

//function
const onClickSearch = ()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  const sort = sortType.value
  const word = inputSearch.value
  let params = {
    keyword: word,
    companyIdx:companyIdx,
    sortType:sort,
    actionType:'1'
  }

  BbsService.getBehaviorList(params).then(
    (response) => {
      items.value = response.result
      _.forEach(items.value, (val, key)=>{
        if(val.sortType == '1')
          val.sortTypeText = t('message.behavior')
        else if(val.sortType == '2')
          val.sortTypeText = t('message.status')
      })
      totalCnt.value = response.result.length
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const confirmDelete = ()=>{
  if(import.meta.env.MODE == 'development') {
    selected.value.forEach((item)=>{
      const idx = items.value.findIndex((tempItem)=> {return tempItem.idx === item.idx})
      if (idx > -1) items.value.splice(idx, 1)
    })

    snackText.value = 'success'
    snackbar.value = true
  }
  else{
    let companyIdx = localStorage.getItem('companyIdx')
    if(!companyIdx)
      utils.movePage('/login')

    let deleteArr = []
    selected.value.forEach((item)=>{
      deleteArr.push(item.idx)
    })
    let params = {
      companyIdx:companyIdx,
      deleteArr: deleteArr,
    }

    BbsService.deleteBehavior(params).then(
      (response) => {
        if(response.success) {
          selected.value.forEach((item)=>{
            const idx = items.value.findIndex((tempItem)=> {return tempItem.idx === item.idx})
            if (idx > -1) items.value.splice(idx, 1)
          })

          totalCnt.value = items.value?.length
          snackText.value = 'success'
          snackbar.value = true
        }
        else{
          snackText.value = response.message
          snackbar.value = true
        }
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

const onClickCopy = (idx)=>{
  dialogCopyModel.value=true
  copyIdx = idx
}

const confirmCopy = ()=>{
  if(import.meta.env.MODE == 'development') {
    snackText.value = 'success'
    snackbar.value = true
  }
  else{
    let companyIdx = localStorage.getItem('companyIdx')
    if(!companyIdx)
      utils.movePage('/login')

    let copyArr = []
    copyArr.push(copyIdx)
    let params = {
      companyIdx:companyIdx,
      copyArr: copyArr,
    }

    BbsService.copyBehavior(params).then(
      (response) => {
        if(response.success) {
          snackText.value = 'success'
          snackbar.value = true
          onClickSearch()
        }
        else{
          snackText.value = response.message
          snackbar.value = true
        }
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

const onClickViewPage = (event, row)=>{
  if(row)
    storeRef.viewIdx.value = row.item.idx
  else
    storeRef.viewIdx.value = null
  utils.movePage('/actionManagementListDetail/'+storeRef.viewIdx.value)
}
</script>


<style lang="scss" scoped>
</style>
